/** Render the total number of search results above all the search widgets in the search sidebar
 */
import React from 'react';

import './SearchCountWidget.styl';

class SearchCountWidget extends React.Component {
  render() {
    if (this.props.count > 0) {
      let countText;
      if (this.props.count === 1) {
        countText = `One call`;
      } else {
        countText = `${this.props.count} results`;
      }
      return <span className="search-count-widget">({countText})</span>;
    }
    return null;
  }
}

export default SearchCountWidget;
